import React from "react";
import { Link } from "react-router-dom";

const ConfigResult = ({ id, title, deleteConfig }) => {
  const url = `/configuration/${id}`;

  return (
    <li className="flex justify-between items-center p-4 hover:bg-surface-container-high bg-surface-container transition rounded-lg mb-3">
      <h3 className="text-lg font-semibold text-white">
        <Link to={url} className="hover:underline">
          {title}
        </Link>
      </h3>
    </li>
  );
};

ConfigResult.defaultProps = {
  deleteConfig: () => {},
};

export default ConfigResult;